import { axios } from '../index'

const resource = "/v1/stay/cafe";

export default {

    checkCafeAvailable() {
        return axios.get(`${resource}/check`);
    }

};